import React from 'react';
import { connect } from 'react-redux';
import { TextTranslateString } from '../Components/TextTranslate/TextTranslate';

function BooleanToString({condition, currentLanguage, translations}) {
	return (
		condition ?
			TextTranslateString('word-yes', "Yes", currentLanguage, translations) :
			TextTranslateString('word-no', "No", currentLanguage, translations)
	)
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
	translations: state.translations?.translations,
});

export default connect(mapStateToProps)(BooleanToString);